import { useLanguage } from '../../context/LanguageContext';
import { techLogos } from '../../data/webServicesData';
import AnimateIn from '../AnimateIn';

const LogoMarquee = () => {
  const { t } = useLanguage();
  const items = [...techLogos, ...techLogos];

  return (
    <section className="py-16 md:py-20 border-y border-white/[0.06] overflow-hidden" data-testid="logo-marquee-section">
      <AnimateIn className="text-center mb-10 px-6">
        <p className="accent-tag justify-center">{t('techTag')}</p>
        <h2
          className="text-2xl md:text-3xl font-bold tracking-[-0.02em] text-white"
          style={{ fontFamily: "'Syne', sans-serif" }}
          data-testid="marquee-title"
        >
          {t('techTitle')}
        </h2>
      </AnimateIn>

      <div
        className="relative"
        style={{
          maskImage: 'linear-gradient(90deg, transparent, black 12%, black 88%, transparent)',
          WebkitMaskImage: 'linear-gradient(90deg, transparent, black 12%, black 88%, transparent)',
        }}
      >
        <div className="marquee-track" data-testid="logo-marquee-track">
          {items.map(([slug, name], i) => (
            <div key={`${slug}-${i}`} className="flex items-center gap-3 mx-8 shrink-0 opacity-60 hover:opacity-100 transition-opacity">
              <img
                src={`https://cdn.simpleicons.org/${slug}/ffffff`}
                alt={name}
                className="w-7 h-7"
                loading="lazy"
                draggable={false}
                onError={(e) => { e.currentTarget.parentElement.style.display = 'none'; }}
              />
              <span className="text-sm font-medium text-gray-300 whitespace-nowrap">{name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoMarquee;
